<!--
 * @Description: 个人中心主入口
 * @Author: gao shuai
 * @Date: 2020-06-13 11:32:01
 * @LastEditTime: 2020-08-19 14:49:10
 * @LastEditors: gao shuai
-->
<template>
  <div class="main">
    <div class="header">
      <div class="headbox clearfix">
        <div class="logo">
          <img src="../../assets/images/logo.png" alt="" />
        </div>
        <ul class="navbox clearfix">
          <li>
            <span class="icon1" @click="refresh('/main/home')">首页</span>
          </li>
          <li>
            <span class="icon1" @click="refresh('/main/Ordermanagement')"
              >订单管理</span
            >
          </li>
          <li>
            <span class="icon1" @click="refresh('/main/Zoningmanagement')"
              >分区管理</span
            >
          </li>
          <li>
            <span class="icon1" @click="refresh('/main/DA')">数据分析</span>
          </li>
          <li>
            <span class="icon1" @click="refresh('/personal')">个人中心</span>
          </li>
           <li v-if="$store.state.isEnabledPaid">
            <span class="icon1" @click="refresh('/behalf')">代付管理</span>
          </li>
          <li v-if="userType">
            <span class="icon1" @click="refresh('/agentsystem')">代理系统</span>
          </li>
        </ul>
        <div class="count">{{ nickName }}</div>
      </div>
    </div>
    <div class="container">
      <div class="midleContaner">
        <div class="slider">
          <div class="top_tit">个人中心</div>
          <ul>
            <li>
              <span class="icon1" @click="refresh('/personal/baseInfo')"
                >用户信息</span
              >
            </li>
            <li>
              <span class="icon7" @click="refresh('/personal/password')"
                >二级密码</span
              >
            </li>
            <li>
              <span class="icon2" @click="refresh('/personal/weixin')"
                >微信绑定</span
              >
            </li>
            <li>
              <span class="icon3" @click="refresh('/personal/recoder')"
                >结算记录</span
              >
            </li>
            <li>
              <span class="icon4" @click="refresh('/personal/acountsafe')"
                >账号安全</span
              >
            </li>
            <li>
              <span class="icon5" @click="refresh('/personal/conectKey')"
                >通讯密钥</span
              >
            </li>
            <li>
              <span class="icon6" @click="refresh('/personal/Userlogs')"
                >用户日志</span
              >
            </li>
            <li>
              <span class="icon2" @click="refresh('/personal/wechat')"
                >微信验证</span
              >
            </li>
          </ul>
        </div>
        <div class="contentbox">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'personal',
  inject: ['reload'],
  data() {
    return {};
  },
  computed: {
    ...mapState(['userType', 'nickName'])
  },
  methods: {
    // 获取用户信息
    getUser() {
      this.$api.home
        .getUserinfo()
        .then(data => {
          this.$store.commit('saveuuid', data.data.uuid);
          this.$store.commit('saveType', data.data.type);
          this.$store.commit('changeNickName', data.data.userName);
          this.$store.commit('changeId', data.data.id);
        })
        .catch(err => {
          this.$messageError(err.message);
        });
    },
    // 跳转路由刷新
    refresh(path) {
      if (this.$route.path.indexOf(path) > -1) {
        this.reload();
      } else {
        this.$router.push({
          path: path
        });
      }
    }
  },
  created() {
    this.getUser();
  }
};
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  padding-top: 60px;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: #e6edf5;

  .header {
    position: absolute;
    width: 100%;
    height: 60px;
    top: 0;
    left: 0;
    background: #63dcfa;

    .headbox {
      width: 80vw;
      margin: 0 auto;
      height: 60px;

      .logo {
        margin-top: 13px;
        float: left;
      }

      .navbox {
        float: left;
        margin-top: 15px;
        margin-left: 50px;

        li {
          float: left;
          padding: 0 35px;
          height: 28px;
          line-height: 28px;
          border-right: 1px solid #fff;
          color: #fff;
          font-size: 16px;

          span {
            cursor: pointer;
          }
        }
      }

      .count {
        float: right;
        height: 28px;
        line-height: 28px;
        padding: 0 20px;
        margin-right: 30px;
        font-size: 19px;
        color: #fff;
        margin-top: 15px;
      }
    }
  }

  .container {
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
      border-radius: 10px;
    }

    .midleContaner {
      width: 80vw;
      margin: 20px auto 22px;
      position: relative;

      // box-shadow: 0 0 10px rgba(0, 0, 0, .25);
      .slider {
        position: absolute;
        width: 160px;
        background: #59bfe7;
        height: 100%;
        left: 0;
        top: 0;

        .top_tit {
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          color: #59bfe7;
          background: #fff url(../../assets/images/line_big.png) no-repeat 0
            center;
        }

        ul {
          margin-top: 30px;

          li {
            height: 35px;
            line-height: 35px;
            margin-bottom: 10px;
            color: #fff;
            font-size: 14px;

            span {
              display: block;
              cursor: pointer;
              height: 35px;
              padding-left: 66px;

              &.icon1 {
                background: url(../../assets/images/p_icon1.png) no-repeat 39px
                  center;
                background-size: auto 22px;
              }

              &.icon2 {
                background: url(../../assets/images/p_icon2.png) no-repeat 39px
                  center;
                background-size: auto 20px;
              }

              &.icon3 {
                background: url(../../assets/images/p_icon3.png) no-repeat 40px
                  center;
                background-size: auto 18px;
              }

              &.icon4 {
                background: url(../../assets/images/p_icon4.png) no-repeat 39px
                  center;
                background-size: auto 20px;
              }

              &.icon5 {
                background: url(../../assets/images/p_icon5.png) no-repeat 40px
                  center;
                background-size: auto 18px;
              }

              &.icon6 {
                background: url(../../assets/images/p_icon6.png) no-repeat 39px
                  center;
                background-size: auto 19px;
              }

              &.icon7 {
                background: url(../../assets/images/p_icon7.png) no-repeat 39px
                  center;
                background-size: auto 22px;
              }
            }
          }
        }
      }

      .contentbox {
        min-height: 800px;
        margin-left: 178px;
      }
    }
  }

  .areaContainer {
    padding: 0 0 20px 15px;

    li {
      position: relative;
      float: left;
      border: 1px solid #ddd;
      padding: 4px;
      cursor: pointer;
      margin-right: 17px;

      .imgbox {
        padding: 15px 8px;
      }

      .mask {
        display: none;
        position: absolute;
        top: 4px;
        left: 4px;
        width: 112px;
        height: 90px;
        background: rgba(0, 0, 0, 0.7);
        color: #fff;
        text-align: center;
        line-height: 90px;
      }

      &:hover {
        border-color: #00b066;

        .mask {
          display: block;
        }
      }

      img {
        display: block;
      }
    }
  }
}
</style>
